import dynamic from 'next/dynamic'

export const ClientSliderPagination = dynamic(
	() => import('./slider-pagination').then(({ SliderPagination }) => SliderPagination),
	{
		ssr: false
	}
)
